module.exports = "/_next/static/images/335a64b6da090d87f18c14ee525aedd8-features-meal-sm.jpg.webp";